export const RECEIVE_PARTNERS_MAINTENANCE = 'RECEIVE_PARTNERS_MAINTENANCE';
